/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Gpestimatedticketsize_Modal_Titlemaximum5Inputs */

const en_coinvestments_gpestimatedticketsize_modal_titlemaximum5 = /** @type {(inputs: Coinvestments_Gpestimatedticketsize_Modal_Titlemaximum5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Est. Max. Ticket Size`)
};

/**
* | output |
* | --- |
* | "Est. Max. Ticket Size" |
*
* @param {Coinvestments_Gpestimatedticketsize_Modal_Titlemaximum5Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_gpestimatedticketsize_modal_titlemaximum5 = /** @type {((inputs?: Coinvestments_Gpestimatedticketsize_Modal_Titlemaximum5Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Gpestimatedticketsize_Modal_Titlemaximum5Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_gpestimatedticketsize_modal_titlemaximum5(inputs)
});
export { coinvestments_gpestimatedticketsize_modal_titlemaximum5 as "coInvestments_gpEstimatedTicketSize_modal_titleMaximum" }